import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useCollections() {
  const { getCollections } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["collections"],
    queryFn: () => getCollections(),
    select: (collectionsData) => {
      const allCollectionValues = collectionsData?.data?.map(
        (collection) => collection?.value
      );

      const options = [
        { value: "all", label: "Todos" },
        ...(collectionsData.data || []).map((collection) => ({
          value: collection?.value,
          label: collection?.label,
        })),
      ];

      return {
        options,
        allValues: allCollectionValues, // remove this latter
      };
    },
  });

  return {
    data: data?.options,
    isLoading,
  };
}
